/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowModelEntity } from './WorkflowModelEntity';
import {
    WorkflowModelEntityFromJSON,
    WorkflowModelEntityFromJSONTyped,
    WorkflowModelEntityToJSON,
    WorkflowModelEntityToJSONTyped,
} from './WorkflowModelEntity';
import type { ProcessTokenEntity } from './ProcessTokenEntity';
import {
    ProcessTokenEntityFromJSON,
    ProcessTokenEntityFromJSONTyped,
    ProcessTokenEntityToJSON,
    ProcessTokenEntityToJSONTyped,
} from './ProcessTokenEntity';

/**
 * 
 * @export
 * @interface WorkflowProcessEntity
 */
export interface WorkflowProcessEntity {
    /**
     * ワークフロープロセスID
     * @type {string}
     * @memberof WorkflowProcessEntity
     */
    id: string;
    /**
     * ワークフロープロセス履歴ID
     * @type {string}
     * @memberof WorkflowProcessEntity
     */
    historyId: string;
    /**
     * プロセス名
     * @type {string}
     * @memberof WorkflowProcessEntity
     */
    name: string;
    /**
     * 説明
     * @type {string}
     * @memberof WorkflowProcessEntity
     */
    description: string;
    /**
     * ワークフローモデル
     * @type {WorkflowModelEntity}
     * @memberof WorkflowProcessEntity
     */
    model: WorkflowModelEntity;
    /**
     * 作成日時
     * @type {Date}
     * @memberof WorkflowProcessEntity
     */
    createdAt: Date;
    /**
     * 更新日時
     * @type {Date}
     * @memberof WorkflowProcessEntity
     */
    updatedAt: Date;
    /**
     * 以下プロセス履歴のプロパティ
     * プロセス履歴を意識せずに扱えるような仕組みを目標
     * @type {ProcessTokenEntity}
     * @memberof WorkflowProcessEntity
     */
    token: ProcessTokenEntity;
    /**
     * プロセスステータス
     * @type {object}
     * @memberof WorkflowProcessEntity
     */
    status: object;
    /**
     * プロセスデータ
     * @type {object}
     * @memberof WorkflowProcessEntity
     */
    data: object;
    /**
     * プロセス履歴種別
     * @type {string}
     * @memberof WorkflowProcessEntity
     */
    type: string;
    /**
     * メタデータ
     * @type {object}
     * @memberof WorkflowProcessEntity
     */
    metadata: object;
    /**
     * ワークフローモデルエンティティのキャッシュ
     * metadataから生成した展開済みのモデルエンティティのキャッシュはここに持つ
     * @type {object}
     * @memberof WorkflowProcessEntity
     */
    definitionEntityCache: object;
}

/**
 * Check if a given object implements the WorkflowProcessEntity interface.
 */
export function instanceOfWorkflowProcessEntity(value: object): value is WorkflowProcessEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('historyId' in value) || value['historyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    if (!('definitionEntityCache' in value) || value['definitionEntityCache'] === undefined) return false;
    return true;
}

export function WorkflowProcessEntityFromJSON(json: any): WorkflowProcessEntity {
    return WorkflowProcessEntityFromJSONTyped(json, false);
}

export function WorkflowProcessEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowProcessEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'historyId': json['historyId'],
        'name': json['name'],
        'description': json['description'],
        'model': WorkflowModelEntityFromJSON(json['model']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'token': ProcessTokenEntityFromJSON(json['token']),
        'status': json['status'],
        'data': json['data'],
        'type': json['type'],
        'metadata': json['metadata'],
        'definitionEntityCache': json['definitionEntityCache'],
    };
}

export function WorkflowProcessEntityToJSON(json: any): WorkflowProcessEntity {
    return WorkflowProcessEntityToJSONTyped(json, false);
}

export function WorkflowProcessEntityToJSONTyped(value?: WorkflowProcessEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'historyId': value['historyId'],
        'name': value['name'],
        'description': value['description'],
        'model': WorkflowModelEntityToJSON(value['model']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'token': ProcessTokenEntityToJSON(value['token']),
        'status': value['status'],
        'data': value['data'],
        'type': value['type'],
        'metadata': value['metadata'],
        'definitionEntityCache': value['definitionEntityCache'],
    };
}

